import { Component } from "react"
import PropTypes from "prop-types"
import SingleStencilForm from "./single_stencil_form"
import MultipleStencilForm from "./multiple_stencil_form"

export default class AppletDefaults extends Component {
  static propTypes = {
    ingredientsMetadata: PropTypes.object,
    stencilsMetadata: PropTypes.object,
  }

  state = {
    ingredientsMetadata: this.props.ingredientsMetadata,
  }

  UNSAFE_componentWillMount() {
    if (window._ingredientList === undefined) {
      window._ingredientList = {}
    }
    window._ingredientList.callback = data => {
      this.setState({ ingredientsMetadata: data })
    }
  }

  render() {
    const ingredientsMetadata = {
      trigger: {
        ...this.state.ingredientsMetadata.trigger,
        ingredients: this.state.ingredientsMetadata.ingredients,
        service: this.state.ingredientsMetadata.service,
      },
    }

    const { stencilsMetadata } = this.props

    const longPostForm = ["title", "html", "tags"].map(
      name => stencilsMetadata[name]
    )
    const plaintextFileForm = ["filename", "folder", "body"].map(
      name => stencilsMetadata[name]
    )
    const spreadsheetForm = ["collection_title", "spreadsheet"].map(
      name => stencilsMetadata[name]
    )

    return (
      <section>
        <SingleStencilForm
          stencil={stencilsMetadata.mobile}
          ingredientsMetadata={ingredientsMetadata}
          platformUnpublished={this.props.platformUnpublished}
        />
        <SingleStencilForm
          stencil={stencilsMetadata.message}
          ingredientsMetadata={ingredientsMetadata}
          platformUnpublished={this.props.platformUnpublished}
        />
        <MultipleStencilForm
          stencils={longPostForm}
          ingredientsMetadata={ingredientsMetadata}
          platformUnpublished={this.props.platformUnpublished}
        />
        <MultipleStencilForm
          stencils={plaintextFileForm}
          ingredientsMetadata={ingredientsMetadata}
          platformUnpublished={this.props.platformUnpublished}
        />
        <MultipleStencilForm
          stencils={spreadsheetForm}
          ingredientsMetadata={ingredientsMetadata}
          platformUnpublished={this.props.platformUnpublished}
        />
        <SingleStencilForm
          stencil={stencilsMetadata.spoken}
          ingredientsMetadata={ingredientsMetadata}
          platformUnpublished={this.props.platformUnpublished}
        />
        <SingleStencilForm
          stencil={stencilsMetadata.calendar}
          ingredientsMetadata={ingredientsMetadata}
          platformUnpublished={this.props.platformUnpublished}
        />
      </section>
    )
  }
}

AppletDefaults.propTypes = {
  ingredientsMetadata: PropTypes.object,
  stencilsMetadata: PropTypes.object,
  fieldName: PropTypes.string,
  platformUnpublished: PropTypes.bool.isRequired,
}

AppletDefaults.defaultProps = {
  fieldName: "partner_trigger_stencil[value]",
}
